import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=120eb79d&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"
import style0 from "./Share.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Share.vue?vue&type=style&index=1&id=120eb79d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120eb79d",
  null
  
)

export default component.exports